export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[620px] md:min-h-[680px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20abstract%20background%20with%20soft%20gradient%20from%20deep%20red%20to%20dark%20charcoal%2C%20subtle%20film%20grain%20texture%2C%20atmospheric%20movie%20theater%20aesthetic%2C%20luxurious%20dark%20ambiance%20with%20gentle%20light%20rays%2C%20premium%20streaming%20platform%20visual%20style&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="天美影视主视觉背景"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-24 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-400/30 mb-6">
              <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
              <span className="text-xs md:text-sm font-medium text-primary-200 whitespace-nowrap">
                2026暑期档 · 热播追剧季
              </span>
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-4">
              天美影视 · 高清电视剧追剧平台
            </h1>

            <p className="text-base md:text-lg text-primary-100 font-heading font-semibold mb-6">
              不缓冲 不卡顿 追剧就该这么爽
            </p>

            <p className="text-sm md:text-base text-background-200/90 leading-relaxed max-w-2xl mx-auto lg:mx-0 mb-8">
              天美影视电视剧大全，收录最新电视剧全集高清免费在线观看资源。平台覆盖国产剧、港剧、台剧、韩剧、日剧、美剧等丰富类型，
              采用全球CDN加速技术确保播放流畅不缓冲。每日同步更新热门剧集，支持1080P至4K超清画质，
              纯净无广告的观影环境，让您沉浸式畅享追剧乐趣。当前暑期档热播《庆余年第二季》《藏海花》等口碑大剧，追剧正当时。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              {[
                { value: '5000+', label: '剧集资源' },
                { value: '4K HDR', label: '超清画质' },
                { value: '每日更新', label: '同步追剧' },
              ].map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl font-bold text-accent-400 font-heading">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-background-300 mt-1">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-lg transition-all whitespace-nowrap cursor-pointer text-center"
              >
                <i className="ri-play-circle-line mr-2"></i>
                立即追剧
              </a>
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold text-white border border-white/30 hover:bg-white/10 rounded-lg transition-all whitespace-nowrap cursor-pointer text-center"
              >
                <i className="ri-fire-line mr-2"></i>
                热度排行
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20drama%20visual%20collage%20with%20multiple%20popular%20TV%20series%20scenes%20arranged%20artistically%2C%20warm%20lighting%20with%20golden%20and%20amber%20accents%2C%20movie%20poster%20aesthetic%2C%20elegant%20composition%20with%20deep%20shadows&width=700&height=500&seq=hero-visual-main&orientation=landscape"
                alt="天美影视热门剧集主视觉"
                className="w-full h-auto rounded-2xl"
              />
              <div className="absolute -bottom-3 -right-3 md:-bottom-4 md:-right-4 bg-background-50/95 backdrop-blur-md rounded-xl px-4 py-3 border border-background-200/40">
                <div className="flex items-center gap-2">
                  <div className="flex items-center">
                    <i className="ri-star-fill text-accent-400 text-sm"></i>
                    <span className="text-xs font-bold text-foreground-900 ml-1">9.8</span>
                  </div>
                  <span className="text-xs text-foreground-500">|</span>
                  <span className="text-xs text-foreground-600 font-medium whitespace-nowrap">《狂飙》</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}